import React, { useCallback } from 'react';
import { UseFormHandleSubmit, UseFormReset } from 'react-hook-form';
import { HealtheraButton } from '../../../../../../healtheraComponents';
import { Questionnaire } from '../../../../types';
import { useSelector } from 'react-redux';
import { selectIsEditingAnyQuestion, selectQuestions } from '../../../../../../redux/questionnaire/selectors';
import { enqueueSnackbar } from 'notistack';
import { useUpdateQuestionnaire } from '../hooks/useUpdateQuestionnaire';

interface Props {
  handleSubmit: UseFormHandleSubmit<Questionnaire>;
  refetchQuestionnaire: () => void;
  reset: UseFormReset<Questionnaire>;
}

const UpdateButton = ({ handleSubmit, refetchQuestionnaire, reset }: Props) => {
  const handleSuccess = useCallback(() => {
    refetchQuestionnaire();
    reset();
  }, [refetchQuestionnaire, reset]);

  const { updateQuestionnaire, isLoading } = useUpdateQuestionnaire(handleSuccess);
  const questions = useSelector(selectQuestions);
  const isEditingAnyQuestion = useSelector(selectIsEditingAnyQuestion);

  const updateQuestionnaireWithChecks = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (questions.length === 0) {
      enqueueSnackbar('You need to add at least one question to update a questionnaire', { variant: 'error' });
      return;
    }

    if (isEditingAnyQuestion) {
      enqueueSnackbar('You need to finish editing the question before updating a questionnaire', { variant: 'error' });
      return;
    }

    handleSubmit(updateQuestionnaire)(e);
  };

  return (
    <HealtheraButton disabled={isLoading} onClick={updateQuestionnaireWithChecks}>
      Update questionnaire
    </HealtheraButton>
  );
};
export default UpdateButton;
